import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Merge Tailwind class names, resolving conflicts. Used by the new landing UI.
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
